import { Component, Injector, Input, OnInit } from '@angular/core';
import { ContratoService, EmpenhoService } from 'administrativo-lib';
import { ContratoAditamentoService, ContratoRescisaoService, ContratoStorageService } from 'compra-lib';
import { ConfirmationService } from 'primeng/api';
import * as toastr from 'toastr';
import { ProgressoService } from '../../../components/progresso/service/progresso.service';
import { ContratoAditamento } from '../../../entidade/compra/contrato-aditamento.model';
import { ContratoPncp } from '../../../entidade/compra/contrato-pncp.model';
import { ContratoRescisao } from '../../../entidade/compra/contrato-rescisao.model';
import { ContratoStorage } from '../../../entidade/compra/contrato-storage.model';
import { Contrato } from '../../../entidade/compra/contrato.model';
import { Empenho } from '../../../entidade/contabil/empenho.model';
import { Login } from '../../../entidade/login/login';
import { FuncaoService } from '../../../util/funcao.service';
import { PNCPService } from '../../../util/pncp.service';
import { ContratoPncpService } from '../../service/contrato-pncp.service';
import { PncpContratoService } from '../../service/contrato.service';
import { RegistroPncpService } from '../../service/registro-pncp.service';

declare var $: any;
@Component({
  selector: 'app-pncp-contrato-cadastro',
  templateUrl: './pncp-contrato-cadastro.component.html',
  styleUrls: ['./pncp-contrato-cadastro.component.css']
})
export class PncpContratoCadastroComponent implements OnInit {

  @Input() login: Login;
  @Input() contrato: ContratoPncp;
  historicoCompra: Array<any> = new Array<any>();
  arquivoApagando: ContratoStorage = new ContratoStorage();

  public justificativa: string;
  public justificativaEmpenho: string;
  public itemAtual;
  public itemEmpenho;

  resultados: Array<{ item: string, sucesso: boolean, mensagem: string }> = new Array<{ item: string, sucesso: boolean, mensagem: string }>();

  /**
   * Construtor com as injeções de dependencias
   */

  constructor(
    protected injector: Injector,
    protected contratoPncpService: ContratoPncpService,
    protected contratoService: PncpContratoService,
    protected confirmationService: ConfirmationService,
    private pncpService: PNCPService,
    private storage: ContratoStorageService,
    protected progressoService: ProgressoService,
    private funcaoService: FuncaoService,
    private aditamentoService: ContratoAditamentoService,
    private rescisaoService: ContratoRescisaoService,
    private empenhoService: EmpenhoService,
    private service: RegistroPncpService) {
  }

  ngOnInit(): void {
  }

  abrirPncp(tipo: 'C' | 'L') {
    const ano = (tipo == 'L' ? this.contrato.contrato.licitacao.exercicio.ano : new Date(this.contrato.contrato.data_assinatura).getFullYear());
    const sequencial = (tipo == 'L' ? this.contrato.contrato.licitacao.sequencial_pncp : this.contrato.contrato.sequencial_pncp);

    window.open(this.pncpService.abrirPortalPNCP(this.contrato.contrato.orgao.cnpj, ano, `/${sequencial}`, tipo == 'L' ? 'E' : 'C'), '_blank');
  }

  idPncp(tipo: 'C' | 'L'): string {
    if (tipo == 'L') {
      return `${this.login.orgao.cnpj.replace(/\D/g, '')}-1-${("000000" + this.contrato.contrato.licitacao.sequencial_pncp).slice((this.contrato.contrato.licitacao.sequencial_pncp + '').length)}/${this.contrato.contrato.licitacao.exercicio.ano}`;
    } else {
      return `${this.login.orgao.cnpj.replace(/\D/g, '')}-1-${("000000" + this.contrato.contrato.sequencial_pncp).slice((this.contrato.contrato.sequencial_pncp + '').length)}/${new Date(this.contrato.contrato.data_assinatura).getFullYear()}`;
    }
  }

  apagarContrato() {
    this.confirmationService.confirm({
      header: 'Apagar Contrato',
      message: `<pre>Confirma a exclusão desse contrato? Essa ação NÃO pode ser desfeita.</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      // key: 'apagarContrato',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        this.pncpService.excluirContrato(this.contrato.contrato).subscribe(async (res) => {
          const relations = 'favorecido,orgao,orgao.cidade,prazo,entrega,tipo_contratacao,licitacao,'
            + 'modalidade,licitacao_audesp,fiscais,licitacao.exercicio';
          const cont: Contrato = await this.contratoService.obter({ relations: relations, id: this.contrato.contrato.id, 'orgao.id': this.login.orgao.id }).toPromise();
          cont.excluido_pncp = true;
          cont.sequencial_pncp = null;
          cont.cadastrado_pncp = false;
          cont['ignoreContabilizacao'] = true;
          await this.contratoService.atualizarContratoPncp(cont.id, false).toPromise();
          window.location.reload();
        }, (e) => {
          toastr.error('Erro ao encontrar contrato no PNCP.')
        });
      }
    });
  }

  enviarArquivoConfirma(item: ContratoStorage) {
    if (!item.tipo_documento) {
      toastr.warning('Tipo de documento para o PNCP não informado');
      return;
    }
    this.confirmationService.confirm({
      header: 'Envio de documento',
      message: `<pre>Confirma o envio do arquivo?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      // key: 'enviarArquivoConfirma',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        this.enviarArquivo(item);
      }
    });
  }

  enviarTodos() {
    this.confirmationService.confirm({
      header: 'Envio de documento',
      message: `<pre>Confirma o envio de todos documentos não enviados?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        for (const a of this.contrato.contrato.arquivos) {
          if (a.tipo_documento == 12 || a.tipo_documento == 16 || !a.sequencial_pncp) {
            this.enviarArquivo(a);
          }
        }
      }
    });

  }

  enviarArquivo(item: ContratoStorage) {
    const aux = Object.assign({}, this.contrato.contrato);
    aux.arquivos = [];
    item.contrato = aux;
    this.pncpService.enviarArquivoContrato(item).subscribe((idTransacao) => {
      this.progressoService.show(idTransacao, async (retorno) => {
        this.resultados = retorno;
        if (this.resultados[0].sucesso) {
          const index = this.contrato.contrato.arquivos.indexOf(item);
          item.sequencial_pncp = +this.resultados[0].mensagem.split(':')[1];
          this.contrato.contrato.arquivos[index] = item;
        }
      });
    }, e => {
      this.funcaoService.acaoErro(e);
    });
  }

  confirmaArquivoTermo(item: ContratoStorage) {
    if (!item.vinculo_id) {
      toastr.warning('Necessário informar o vínculo do documento');
      return;
    }
    this.confirmationService.confirm({
      header: 'Envio de documento',
      message: `<pre>Confirma o envio do arquivo?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        this.enviarArquivoTermo(item)
      }
    });
  }

  enviarArquivoTermo(item: ContratoStorage) {
    const aux = Object.assign({}, this.contrato.contrato);
    aux.arquivos = [];
    item.contrato = aux;
    this.pncpService.enviarArquivoTermo(item).subscribe((idTransacao) => {
      this.progressoService.show(idTransacao, async (retorno) => {
        this.resultados = retorno;
        if (this.resultados[0].sucesso) {
          const index = this.contrato.contrato.arquivos.indexOf(item);
          item.sequencial_pncp = +this.resultados[0].mensagem.split(':')[1];
          this.contrato.contrato.arquivos[index] = item;
        }
      });
    }, e => {
      this.funcaoService.acaoErro(e);
    });
  }

  enviarTodosTermos() {
    this.confirmationService.confirm({
      header: 'Envio de documento',
      message: `<pre>Confirma o envio dos documentos pendentes?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        for (const a of this.contrato.contrato.arquivos) {
          if ((a.tipo_documento != 12 && a.tipo_documento != 16) || !a.tipo_documento) {
            if (!a.vinculo_id) {
              toastr.warning('Documento sem vinculo informado, não enviado');
              continue;
            }

            this.enviarArquivoTermo(a);
          }
        }
      }
    });
  }

  apagarArquivo(item: ContratoStorage) {
    this.confirmationService.confirm({
      header: 'Apagar documento',
      message: `<pre>Confirma a remoção do documento?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.pncpService.apagarArquivoContrato(item).subscribe(async (res) => {
          const index = this.contrato.contrato.arquivos.indexOf(item);
          const seq = item.sequencial_pncp;
          item.sequencial_pncp = null;
          await this.storage.atualizar(item).toPromise();
          this.contrato.contrato.arquivos[index] = item;
          this.fecharDlgApagarArquivo();
          toastr.success('Arquivo removido com sucesso do pncp!');
        }, e => {
          if (e.error?.message) {
            toastr.error(e.error.message);
          } else {
            this.funcaoService.acaoErro(e);
          }
        });
      }
    });
  }

  async apagarArquivoTermo(item: ContratoStorage) {
    this.confirmationService.confirm({
      header: 'Apagar documento',
      message: `<pre>Confirma a remoção do documento?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.justificativa = '';
        this.itemAtual = item;
        $('#dialogJustificativa').modal('show');
      }
    });
  }

  dlgApagarArquivo(item: ContratoStorage) {
    this.arquivoApagando = item;
    $('#dlgApagarItem').modal('show');
  }

  fecharDlgApagarArquivo() {
    this.arquivoApagando = new ContratoStorage();
    $('#dlgApagarItem').modal('hide');
  }

  confirmarEnvioAditivo(tipo: 'A' | 'R') {
    let texto = '';
    const envios = [];
    if (tipo == 'A') {
      for (const a of this.contrato.contrato.aditamentos) {
        if (a['enviar']) {
          texto += '\n' + a.numero + ' - ' + a.finalidade + (` (${a.sequencial_pncp ? 'Retificação' : 'Novo'})`);
          envios.push(a.id);
        }
      }
    } else if (tipo == 'R') {
      for (const a of this.contrato.contrato.rescisoes) {
        if (a['enviar']) {
          texto += '\n' + a.id + ' - ' + a.motivo + (` (${a.sequencial_pncp ? 'Retificação' : 'Novo'})`);
          envios.push(a.id);
        }
      }
    }

    this.confirmationService.confirm({
      header: 'Envio de Termos do Contrato',
      message: `<pre>Confirma o envio dos sequinte itens? ${texto}</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envios.',
      rejectLabel: 'Não',
      accept: async () => {
        this.pncpService.enviarTermos((tipo == 'A' ? envios : null), (tipo == 'R' ? envios : null)).subscribe((idTransacao) => {
          this.progressoService.show(idTransacao, async (retorno) => {
            this.resultados = retorno;
          });
        }, e => {
          this.funcaoService.acaoErro(e);
        });
      }
    });
  }

  apagarAditivo(item, tipo: 'A' | 'R') {
    this.confirmationService.confirm({
      header: 'Apagar Termo',
      message: `<pre>Confirma a remoção do Termo de contrato dos registros do PNCP?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        this.pncpService.apagarTermo(this.contrato.contrato, item.sequencial_pncp).subscribe(async (res) => {
          if (tipo == 'A') {
            const adt = await this.aditamentoService.obter({ id: item.id, relations: 'contrato,contrato.orgao,exercicio,usuario,tipo' }).toPromise();
            adt.cadastrado_pncp = false;
            adt.sequencial_pncp = null;
            adt['pular_escrituracao'] = true;
            this.aditamentoService.atualizar(adt).subscribe(() => {
              item.cadastrado_pncp = false;
              item.sequencial_pncp = null;
              toastr.success('Sucesso ao remover registro do pncp');
            }, (e) => {
              this.funcaoService.acaoErro(e);
            });
          } else {
            const res = await this.rescisaoService.obter({ id: item.id, relations: 'usuario,contrato' }).toPromise();
            res.cadastrado_pncp = false;
            res.sequencial_pncp = null;
            this.rescisaoService.atualizar(res).subscribe((res) => {
              item.cadastrado_pncp = false;
              item.sequencial_pncp = null;
              toastr.success('Sucesso ao remover registro do pncp');
            }, (e) => {
              this.funcaoService.acaoErro(e);
            });
          }
        }, e => {
          if (e.error?.message) {
            toastr.error(e.error.message);
          } else {
            this.funcaoService.acaoErro(e);
          }
        });
      }
    });

  }

  async voltarEnvios(tipo: 'A' | 'R') {
    const atualiza = this.resultados.find(r => r.sucesso);
    this.resultados = new Array<{ item: string, sucesso: boolean, mensagem: string }>();
    if (tipo == 'A' && atualiza) {
      this.contrato.contrato.aditamentos = await (await this.aditamentoService.filtrar(0, -1, { 'contrato.id': this.contrato.contrato.id }).toPromise()).content;
    } else if (tipo == 'R' && atualiza) {
      this.contrato.contrato.rescisoes = await (await this.rescisaoService.filtrar(0, -1, { 'contrato.id': this.contrato.contrato.id }).toPromise()).content;
    }
  }

  async buscarHistoricoContrato() {
    this.historicoCompra = await this.pncpService.consultarHistoricoContrato(this.login.orgao.cnpj.replace(/[./-]/g, ''), this.contrato.contrato.ano, this.contrato.contrato.sequencial_pncp).toPromise();
  }

  public async confirmarExclusaoTermo() {
    if (!this.justificativa || this.justificativa == '') {
      toastr.warning(`Informe a justificativa para exclusão do arquivo.`)
      return
    }
    if (this.justificativa.length > 255) {
      toastr.warning(`A justificativa deve ter no maximo 255 caracteres.`)
      return
    }
    let aditivo: ContratoAditamento;
    let rescicao: ContratoRescisao;

    if (this.itemAtual.tipo_documento == 14 && this.itemAtual.vinculo_id) {
      aditivo = await this.aditamentoService.obterId(this.itemAtual.vinculo_id).toPromise();
    }
    if (this.itemAtual.tipo_documento == 13 && this.itemAtual.vinculo_id) {
      rescicao = await this.rescisaoService.obterId(this.itemAtual.vinculo_id).toPromise();
    }
    if (this.itemAtual.vinculo_id) {
      this.pncpService.apagarArquivoTermo(this.itemAtual, (aditivo ? aditivo.sequencial_pncp : rescicao ? rescicao.sequencial_pncp : this.itemAtual.sequencial_pncp), this.justificativa
      ).subscribe(async (res) => {
        const index = this.contrato.contrato.arquivos.indexOf(this.itemAtual);
        const seq = this.itemAtual.sequencial_pncp;
        this.itemAtual.sequencial_pncp = null;
        await this.storage.atualizar(this.itemAtual).toPromise();
        this.contrato.contrato.arquivos[index] = this.itemAtual;
        this.fecharDlgApagarArquivo();
        toastr.success('Arquivo removido com sucesso do pncp!');
        $('#dialogJustificativa').modal('hide');
        window.location.reload();
      }, e => {
        if (e.error?.message) {
          toastr.error(e.error.message);
        } else {
          this.funcaoService.acaoErro(e);
        }
      });
    } else {
      this.itemAtual['justificativa'] = this.justificativa
      this.pncpService.apagarArquivoContrato(this.itemAtual).subscribe(async (res) => {
        const index = this.contrato.contrato.arquivos.indexOf(this.itemAtual);
        const seq = this.itemAtual.sequencial_pncp;
        this.itemAtual.sequencial_pncp = null;
        await this.storage.atualizar(this.itemAtual).toPromise();
        this.contrato.contrato.arquivos[index] = this.itemAtual;
        this.fecharDlgApagarArquivo();
        toastr.success('Arquivo removido com sucesso do pncp!');
        $('#dialogJustificativa').modal('hide');
        window.location.reload();
      }, e => {
        if (e.error?.message) {
          toastr.error(e.error.message);
        } else {
          this.funcaoService.acaoErro(e);
        }
      });
    }

  }

  confirmarEnvioEmpenho(item: Empenho) {
    let texto = '';
    const envios = [];

    this.confirmationService.confirm({
      header: 'Envio de Empenhos do Contrato',
      message: `<pre>Confirma o envio dos seguinte itens? ${texto}</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envios.',
      rejectLabel: 'Não',
      accept: async () => {
        this.empenhoService.obter({
          id: item.id,
          relations: 'contrato.orgao,ficha.despesa,ficha.aplicacao_variavel,favorecido.tipo'
        })
          .subscribe((empenho) => {
            this.pncpService.inserirEmpenho(empenho).subscribe((retorno) => {
              this.resultados.push({ item: retorno[0].numeroEmpenho, sucesso: true, mensagem: `Sucesso ao ser enviado, Identificador no PNCP: ${retorno[0].sequencialEmpenho}` });
              this.empenhoService.atualizarEmpenhoPncp(empenho.id, retorno[0].sequencialEmpenho).subscribe((ret) => {
                item.cadastrado_pncp = true;
                item.sequencial_pncp = retorno[0].sequencialEmpenho;
              })
            }, e => {
              this.resultados.push({ item: empenho.numero + '', sucesso: false, mensagem: `${e.error.message}` });
            })
          })
      }
    });

  }

  async apagarItemEmpenho(item: Empenho) {
    this.confirmationService.confirm({
      header: 'Apagar documento',
      message: `<pre>Confirma a remoção do empenho do PNCP?</pre>`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        this.justificativaEmpenho = '';
        this.itemEmpenho = item;
        $('#dialogJustificativaEmpenho').modal('show');
      }
    });
  }

  public async confirmarExclusaoEmpenho() {
    if (!this.justificativaEmpenho || this.justificativaEmpenho == '') {
      toastr.warning(`Informe a justificativa para exclusão do arquivo.`)
      return
    }
    if (this.justificativaEmpenho.length > 255) {
      toastr.warning(`A justificativa deve ter no maximo 255 caracteres.`)
      return
    }

    this.empenhoService.obter({
      id: this.itemEmpenho.id,
      relations: 'contrato.orgao,ficha.despesa,ficha.aplicacao_variavel,favorecido.tipo'
    }).subscribe((empenho) => {
      this.pncpService.removerEmpenho(empenho, this.justificativaEmpenho
      ).subscribe(async (res) => {
        toastr.success('Empenho removido com sucesso do pncp!');
        this.empenhoService.atualizarEmpenhoPncp(empenho.id, null).subscribe((ret) => {
          empenho.cadastrado_pncp = false;
          empenho.sequencial_pncp = null;
        })
        $('#dialogJustificativa').modal('hide');
        window.location.reload();
      }, e => {
        if (e.error?.message) {
          toastr.error(e.error.message);
        } else {
          console.log(e)
          this.funcaoService.acaoErro(e);
        }
      });
    })

  }
}
